module.exports = __webpack_public_path__ + "img/20.cf01d93c.gif";